// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zamazenta: PokeData = {
  "id": 889,
  "name": "zamazenta",
  "height": 29,
  "weight": 2100,
  "base_experience": 335,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bite",
    "quick-attack",
    "slash",
    "metal-claw",
    "crunch",
    "iron-defense",
    "howl",
    "metal-burst",
    "close-combat",
    "giga-impact",
    "iron-head",
    "wide-guard",
    "moonblast",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "metal-burst",
    "close-combat",
    "moonblast",
    "double-kick",
    "coaching",
    "drain-punch",
    "bulk-up",
    "rolling-kick",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 468,
    "item": null,
    "species": [
      {
        "name": "zamazenta",
        "order": 889,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 153,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
